export default __webpack_public_path__ + "static/media/parameter.ad3610e1.png";